// src/stores/useCollabRailStore.js
import { create } from "zustand";

export const COLLAB_RAIL_WIDTH = 360;

export const useCollabRailStore = create((set, get) => ({
  open: false,          // closed by default
  unreadCount: 0,      // future-ready

  openRail: () => set({ open: true }),
  closeRail: () => set({ open: false }),
  toggleRail: () => set((s) => ({ open: !s.open })),

  setUnread: (n) => set({ unreadCount: n }),
}));